module.exports = __webpack_public_path__ + "img/xp-715.3cad48ee.png";